export default __webpack_public_path__ + "static/media/Arrow_right.32fa00d2.webp";